export const RESTAURANT_TYPE_GROUPS: Array<{
  group: string;
  options: Array<string>;
}> = [
  {
    group: "Service style",
    options: [
      "Fine dining",
      "Casual dining",
      "Fast casual",
      "Fast food / QSR",
      "Café / Coffee shop",
      "Bar / Pub",
      "Food truck",
      "Bakery",
      "Catering",
    ],
  },
  {
    group: "Cuisine",
    options: [
      "American",
      "Mexican",
      "Italian",
      "Chinese",
      "Japanese / Sushi",
      "Indian",
      "Thai",
      "Mediterranean",
      "French",
      "BBQ",
      "Pizza",
      "Seafood",
      "Vegan / Vegetarian",
      "Other",
    ],
  },
];

export const OWNER_ROLES: Array<string> = [
  "Owner",
  "Co-owner",
  "General Manager",
  "Operating Partner",
  "Director of Operations",
  "Franchisee",
  "Other",
];

/** Identifier of the currently displayed T&C; sent with acceptance. */
export const OWNER_TERMS_VERSION = "2026-05-01";

export interface RestaurantAddress {
  formattedAddress: string;
  address1?: string;
  city?: string;
  state?: string;
  zipcode?: string;
  latitude?: number;
  longitude?: number;
}

export interface OwnerOnboardingData {
  restaurantName: string;
  restaurantType: string;
  restaurantImageUrl?: string;
  restaurantAddress?: RestaurantAddress;
  websiteUrl: string;
  ownerRole: string;
  ownerPhotoUrl?: string;
  ownerName: string;
  phone: string;
  termsAccepted: boolean;
  termsVersion?: string;
  billingConfigured: boolean;
  cardBrand?: string;
  cardLast4?: string;
}
